export const GENERIC_IMAGE_DROPZONE_ACCEPT = Object.freeze({
  "image/jpeg": [".jpeg", ".jpg"],
  "image/png": [".png"],
  "image/webp": [".webp"],
  "image/heic": [".heic"],
  "image/heif": [".heif"],
});

export default GENERIC_IMAGE_DROPZONE_ACCEPT;
